import {
  $post, $get, $JsonPost, ebopo, vte,
} from '@/utils/axios-request';


class Person {
  // 个人中心设置课程学习顺序及显示词性
  public async personConfig(postData: any = {}): Promise<any> {
    return await $JsonPost(`${vte}/userStudy/api/v1/personConfig`, postData);
  }
}
export default new Person();
